// import {config,translateKey} from 'reword-js';

const dictionary = {
    'en-US': {
        InHouse: 'IN HOUSE',
        adults: 'Adults',
        arrivals: 'Arrivals',
        departures: 'Departures',
        reservations: 'Reservations',
        bookings: 'BOOKINGS',
        newreservation: 'New Reservation',
        availability: 'Availability',
        AverageDailyRate: 'Average Daily Rate',
        TotalRevenue: 'Total Revenue',
        Occupancy: 'Occupancy',
        AverageStay: 'Average length of Stay',
        InventoryStatistics: 'Inventory Statistics',
        AvailableByType: 'Available By Type',
        today: 'Today',
        tomorrow: 'Tomorrow',
        DayAfterTomorrow: 'Day After Tomorrow',
        nights: 'Nights',
        night: 'Night',
        Visitors: 'Visitors',
        payed: 'Payed',
        unpayed: 'Unpayed',
        AvailableRooms: 'Available rooms',
        AvailabilityAndPrices: 'Availability & Prices',
        SelectRoom: 'Select a Room ',
        activity: 'Activity',
        all: 'All',
        cancellations: 'Cancellations',
        messages: 'Messages',
        EnableNotif: 'Enable Notifications',
        NoNotifFor7Days: 'No notifications for last seven days',
        OpenOrCloseRooms: 'Open or Close rooms',
        SetupAvailability: 'Setup Availability',
        PriceNLimits: 'Price and limits',
        StartBooking: 'Start your booking',
        guest: 'Guest',
        guests: 'Guests',
        agency: 'Agency',
        corporate: 'Corporate',
        search: 'Search',
        checkin: 'Check In',
        checkout: 'Check Out',
        room: 'Room',
        child: 'Child',
        childrens: 'Children',
        continue: 'Continue',
        staydetails: 'Stay Details',
        setdiffdetails: 'Set Different Guest Details Per Room',
        SendConfirmEmail: 'Send Confirmation E-mail to Guest',
        BookingComplete: 'Booking Complete',
        YourBookingIsCompleted: 'Your booking is completed',
        GoToMyBookings: 'Go to my bookings',
        GoToHome: 'Back to home',
        GoToPlan: 'Back to plan',
        TotalPriceFor: 'Total price for ',
        IncludesTaxesNCharges: 'Includes taxes and charges',
        FirstName: 'First Name',
        LastName: 'Last Name',
        EmailAddress: 'E-mail address',
        MobileNumber: 'Mobile Number',
        country: 'Country',
        region: 'Region',
        edit: 'Edit',
        PaymentMethods: 'PAYMENT METHODS',
        BookingID: 'Booking ID',
        before: 'Before ',
        reservationsCalendar: 'Plan',
        notifications: 'Notifications',
        yesterday: 'Yesterday',
        sevendaysbefore: 'Last 7 Days',
        thirtydaysbefore: 'Last Month',
        news: 'News',
        sortby: 'Sort By',
        Calendar: 'Calendar',
        NumerOfRooms: 'Number Of Rooms',
        ChooseRoom: 'Choose your Room',
        reservationInfo: 'Booking information',
        NoShow: 'No Show',
        CancelReservation: ' Cancel Reservation',
        editPrice: 'Edit Price',
        availRooms: 'Available Rooms',
        bookedRooms: 'Booked Rooms',
        searchresult: 'Booking Search',
        invoices: 'Invoices',
        inhouse: 'In House',
        Floor: 'Floor',
    },
    'el-GR': {
        InHouse: 'IN HOUSE',
        adults: 'Eνήλικες',
        arrivals: 'Αφίξεις',
        departures: 'Αναχωρήσεις',
        reservations: 'Κρατήσεις',
        bookings: 'ΚΡΑΤΗΣΕΙΣ',
        newreservation: 'Νέα Κράτηση',
        availability: 'Διαθεσιμότητα',
        AverageDailyRate: 'Average Daily Rate',
        TotalRevenue: 'Total Revenue',
        Occupancy: 'Occupancy',
        AverageStay: 'Μέσος όρος διαμονής ',
        InventoryStatistics: 'Inventory Statistics',
        AvailableByType: 'Διαθεσιμότητα βάσει τύπου δωματίου',
        today: 'Σήμερα',
        tomorrow: 'Αύριο',
        DayAfterTomorrow: 'Μεθαύριο',
        nights: 'Νύχτες',
        night: 'Νύχτα',
        Visitors: 'Επισκέπτες',
        payed: 'Πληρωμένη',
        unpayed: 'Απλήρωτη',
        AvailableRooms: 'Διαθέσιμα δωμάτια',
        AvailabilityAndPrices: 'Διαθεσιμότητα & Τιμές',
        SelectRoom: 'Επιλέξτε Δωμάτιο ',
        activity: 'Δραστηριότητα',
        all: 'Όλα',
        cancellations: 'Ακυρώσεις',
        messages: 'Μηνύματα',
        EnableNotif: 'Ενεργοποίηση ειδοποιήσεων',
        NoNotifFor7Days: 'Καμία ειδοποιήση τις τελευταίες επτά μέρες',
        OpenOrCloseRooms: 'Άνοιγμα ή κλείσιμο δωματιών',
        SetupAvailability: 'Ορισμός Διαθεσιμότητας',
        PriceNLimits: 'Τιμές και όρια',
        StartBooking: 'Ξεκινήστε την κρατησή σας',
        guest: 'Επισκέπτης',
        guests: 'Επισκέπτες',
        agency: 'Πράκτορας',
        corporate: 'Εταιρικός',
        search: 'Αναζήτηση',
        checkin: 'Check In',
        checkout: 'Check Out',
        room: 'Δωμάτιο',
        child: 'Παιδί',
        childrens: 'Παιδιά',
        continue: 'Συνέχεια',
        staydetails: 'Στοιχεία Κράτησης',
        setdiffdetails: 'Εισαγωγή διαφορετικών στοιχείων επισκέπτη ανα Δωμάτιο',
        SendConfirmEmail: 'Αποστολή E-mail επιβεβαίωσης στον επισκέπτη',
        BookingComplete: 'Ολοκλήρωση Κράτησης',
        YourBookingIsCompleted: 'Η κρατησή σας έχει ολοκληρωθεί',
        GoToMyBookings: 'Πήγαινε στις κρατήσεις μου',
        GoToHome: 'Επέστρεψε  στην αρχική',
        GoToPlan: 'Επέστρεψε  στην πλάνο',
        TotalPriceFor: 'Συνολική τιμή για ',
        IncludesTaxesNCharges: 'Περιλαμβάνει φόρους και χρεώσεις',
        FirstName: 'Όνομα',
        LastName: 'Επίθετο',
        EmailAddress: 'Διεύθυνση E-mail',
        MobileNumber: 'Αριθμός κινητού',
        country: 'Χώρα',
        region: 'Περιοχή',
        edit: 'Επεξεργασία',
        PaymentMethods: 'ΜΕΘΟΔΟΙ ΠΛΗΡΩΜΗΣ',
        BookingID: 'Αριθμός κράτησης',
        before: 'Πριν από ',
        reservationsCalendar: 'Πλάνο Κρατήσεων',
        notifications: 'Ειδοποιήσεις',
        yesterday: 'Εχθές',
        sevendaysbefore: 'Τελευταίες 7 Μέρες',
        thirtydaysbefore: 'Τελευταίoς Μήνας',
        news: 'Νέα',
        sortby: 'Ταξινόμηση Ανά',
        Calendar: 'Ημερολόγιο',
        NumerOfRooms: 'Αριθμός Δωματίων',
        ChooseRoom: 'Επιλέξτε Δωμάτιο',
        reservationInfo: 'Πληροφορίες Κράτησης',
        NoShow: 'Μην εμφανίσεις',
        CancelReservation: 'Ακύρωση Κράτησης',
        editPrice: 'Επεξεργασία τιμής',
        availRooms: 'Διαθέσιμα Δωμάτια',
        bookedRooms: 'Κλεισμένα Δωμάτια',
        searchresult: 'Αναζήτηση Κράτησης',
        invoices: 'Τιμολόγια',
        inhouse: 'Εντός Σπιτιού',
        Floor: 'Όροφος',
    },
};

export default dictionary;
